import styled from "styled-components";

const NoDataDiv = styled.div`
  padding: 16px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
const NoDataAligner = styled.div`
  padding: 16px;
  width: 100%;
  background-color: rgba(242, 242, 242, 0.95);
  border-radius: 5px;
`;
const NoDataText = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #808080;
`;

const NoDataComponent = ({ text = "There is no data" }) => {
  return (
    <NoDataDiv>
      <NoDataAligner>
        <NoDataText>{text}</NoDataText>
      </NoDataAligner>
    </NoDataDiv>
  );
};

export default NoDataComponent;
